/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  $('body').on('click','.open_quick_modal', function(e) {
    e.preventDefault();
    $('body').addClass('active_quick_modal');
    var quick_add_modal = $(this).closest('.ProductItem').next('.quick_add_modal'); 
    var cloneModal = quick_add_modal.clone(true);
    cloneModal.addClass('clone_modal');
    $('body').append(cloneModal);
    cloneModal.addClass('active');
  });

  $('body').on('click','.close_quick_add_modal', function(e) {
    e.preventDefault();
    $('body').removeClass('active_quick_modal');
    $(this).closest('.quick_add_modal').removeClass('active');
    setTimeout(function() {
      $(this).closest('.quick_add_modal').remove();
    },500);



  });

  $('body').on('change','.ProductItem__MainSelect', function(e) {
    e.preventDefault();

 
    var val = $(this).val();
    var submitFormBtn = $(this).closest('form').find('.ProductForm__AddToCart');
    var form_error = $(this).closest('form').find('.slidecart-form-error');
    if(form_error.length) {
    	form_error.remove();
    }
                                     
    
    var activeOption = $(this).find('option:selected');
    var isAvailable = activeOption.attr('data-variant-available');
    if(isAvailable == 'true') {
    submitFormBtn.trigger('click');
      $(this).val(' ');
    } else {
    	var form = $(this).closest('form');
      form.append('<div class="error slidecart-form-error">' + window.languages.soldout_grid_text + '</div>');
    }
  });
  
   $('body').on('click','.quick_add_modal  .ProductForm__Variants label', function(e) {
    e.preventDefault();
     
     var input = $(this).prev();
     input.trigger('click');
   });

  $('body').on('change','.quick_add_modal .ProductForm__Option [type="radio"]', function(e) {
    e.preventDefault();

  
    
    var form =  $(this).closest('form');
    var main_select = form.find('.main_select');


   var variantId = $(this).attr('data-variant_id') * 1;
      main_select.val(variantId);
      main_select.trigger('change');

    $(this).removeAttr('checked');
    $(this).prop('checked',false);


  });

  $('body').on('change','.quick_add_modal .main_select', function(e) {
    e.preventDefault();
    
    var self = $(this);
    var quick_add_modalEl = self.closest('.quick_add_modal');

        var items = [];
 
      var variant_id = self.val() * 1;
      var variant_obj =  {
        quantity:1,
        id:variant_id
      };
      items.push(variant_obj);
 
      var data_arr = {
        items: items
      };
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data_arr)
      }).then(function (response) {
        if (response.ok) {


              if($('body').hasClass('active_quick_modal')) {
      $('body').removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
          
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant_id,
              quantity: 1
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
 
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            quick_add_modalEl.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });

  });

  $('body').on('click', function(e) {
    var el = e.target;
    if($(el).hasClass('active_quick_modal')) {
      $(el).removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
  });

  $('body').on('change','.product_option_input', function(e) {
    e.preventDefault();
    var form =  $(this).closest('form');
    var main_select = form.find('.ProductItem__MainSelect');
   
    var ProductItemEl = form.closest('.ProductItem');
    var variantId = $(this).attr('data-variant_id') * 1;
      main_select.val(variantId);
      main_select.trigger('change');

    $(this).removeAttr('checked');
    $(this).prop('checked',false);
  });

  $('body').on('click','.ProductItem__CustomSwatch', function (e) {
    e.preventDefault();

  
    
    var parentItemEl = $(this).closest('.ProductItem');
    if(parentItemEl.length) {

      var ProductItem__ImageLoaderIconEl = parentItemEl.find('.ProductItem__ImageLoaderIcon');
     
      
        var itemUrl = $(this).attr('data-product_url');
      var featuredMedia = $(this).attr('data-product_media');
      var alternateMedia = $(this).attr('data-product_alternate_image');
      var newTitle = $(this).attr('data-product_title');
      var customText = $(this).attr('data-custom-text');
      var newPrice = $(this).attr('data-product_price')*1;   
      var newCompareAtPrice = $(this).attr('data-product_compare_price');
      var newPriceFormatted = $(this).attr('data-product_price-formatted');   
      var newCompareAtPriceFormatted = $(this).attr('data-product_compare_price-formatted');
      var itemId = $(this).attr('data-product-id');

      
     var old_desktop_quick_addEl = parentItemEl.find('.desktop_quick_add:not(.no-js)');
      var news_desktop_quick_addEl = parentItemEl.find('.desktop_quick_add[data-product-id="'+itemId+'"]');
      
      var ProductItem__ImageWrapperEl = parentItemEl.find('.ProductItem__ImageWrapper');
      var ProductItem__ImageEl = parentItemEl.find('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      var ProductItem__ImageAlternateEl = parentItemEl.find('.ProductItem__Image--alternate');
      var ProductItemLinksArr =  parentItemEl.find('a:not(.ProductItem__CustomSwatch)');
      var ProductItem__TitleEl = parentItemEl.find('.ProductItem__Title');
      var ProductItem__Price = parentItemEl.find('.ProductItem__PriceList')
      var ProductItem__CustomText = parentItemEl.find('.ProductItem__CustomText')
      


       if(ProductItem__ImageLoaderIconEl.length) {
        ProductItem__ImageLoaderIconEl.removeClass('no-js');       
        ProductItem__ImageEl.css("visibility", "hidden");
      }
      
      if(ProductItemLinksArr.length) {
        for(const linkEl of ProductItemLinksArr) {
          $(linkEl).attr('href',itemUrl);
        }
      }
      if(ProductItem__TitleEl.length) {
        ProductItem__TitleEl.find('a').html(newTitle);
      }
        //debugger;

      if(ProductItem__ImageEl.length) {

        console.log(featuredMedia);
        ProductItem__ImageEl.attr('data-srcset',featuredMedia);
        ProductItem__ImageEl.attr('srcset',featuredMedia);
        ProductItem__ImageEl.attr('src',featuredMedia);
      }
  
      if(alternateMedia.length) {
            if(ProductItem__ImageAlternateEl.length) {
              console.log(alternateMedia);
        ProductItem__ImageAlternateEl.attr('data-srcset',alternateMedia);
        ProductItem__ImageAlternateEl.attr('srcset',alternateMedia);
        ProductItem__ImageAlternateEl.attr('src',alternateMedia);
        ProductItem__ImageWrapperEl.addClass('ProductItem__ImageWrapper--withAlternateImage');
      }
    } else {      
        ProductItem__ImageWrapperEl.removeClass('ProductItem__ImageWrapper--withAlternateImage');
    }



  
  
      if(news_desktop_quick_addEl.length) {
        news_desktop_quick_addEl.removeClass('no-js');

        if(old_desktop_quick_addEl.length) {
          old_desktop_quick_addEl.addClass('no-js');
        }
      }

    ProductItem__ImageEl[0].addEventListener('load', () => {
      if(ProductItem__ImageLoaderIconEl.length) {          
        setTimeout(() => {
        ProductItem__ImageLoaderIconEl.addClass('no-js');
        ProductItem__ImageEl.css("visibility", "visible");
      }, 300);
      }
  }, { once: true });


    if(ProductItem__CustomText && customText != ""){
       ProductItem__CustomText.html(customText);
     } 
      
     if(ProductItem__Price){
       if(newCompareAtPrice != ""){
         newCompareAtPrice = newCompareAtPrice*1;
         if(newCompareAtPrice > newPrice){
           ProductItem__Price.html("<span class='ProductItem__Price Price Price--highlight Text--subdued'>"+newPriceFormatted+"</span><span class='ProductItem__Price Price Price--compareAt'>"+newCompareAtPriceFormatted+"</span>");
         }else{
           ProductItem__Price.html("<span class='ProductItem__Price Price Text--subdued'>"+newPriceFormatted+"</span>");
         }
       }else{
         ProductItem__Price.html("<span class='ProductItem__Price Price Text--subdued'>"+newPriceFormatted+"</span>");
       }
       
     }   

      
    }
  });

});


// document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("load", (event) => {


  var quick_buy = document.querySelector('.quick-buy');
  if(quick_buy) {
   window.scrollTo(0, 0);
    var static_ProductForm__AddToCart = document.querySelector('.Product__InfoWrapper .ProductForm__AddToCart');
    var bottomOffsetButton  = static_ProductForm__AddToCart.getBoundingClientRect().top + static_ProductForm__AddToCart.offsetHeight;


    
    document.addEventListener('scroll', function(e) {
      var window_scrollY = window.scrollY;
      var header = document.querySelector('.shopify-section--header');
      var scrollY =  window_scrollY;
      
      if(scrollY > bottomOffsetButton) {
        quick_buy.classList.add('quick-buy--visible');
      } else {
        quick_buy.classList.remove('quick-buy--visible');
      }
    });


document.addEventListener('change', function(e){
  	const el = e.target;
    
    if(el.classList.contains('custom_option_wrapper-select') || el.closest('.custom_option_wrapper-select')) {
       e.preventDefault();


      const value  = el.value;
      const selectedOption =  el.options[el.selectedIndex];
      console.log(selectedOption);
      const variant_title = selectedOption.getAttribute('data-variant-title');

      const quick_buy_variantTitleEl = document.querySelector('.quick-buy__product-title .selected_variant_title');
      if(quick_buy_variantTitleEl) {
        quick_buy_variantTitleEl.innerHTML = variant_title;
      }

      const ProductForm__OptionRadioEl = document.querySelector('.ProductForm__OptionRadio[value="'+value+'"]');
                                                                console.log(ProductForm__OptionRadioEl);
        if(ProductForm__OptionRadioEl) {
          ProductForm__OptionRadioEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
  });
    
    
  }
});

$(document).ready(function () {
  $('body').on('click','.VideoActionButton', function(e) {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active');
      $(this).prev().trigger('pause');
    } else {
      $(this).removeClass('active');
      $(this).prev().trigger('play');
    }
  });

   $('body').on('click','.cart_free_product_info_button .select_button', function(e) { 
    var parentWrapper = $(this).closest(".cart_free_product"); 
     var button = $(this); 
     button.attr("disabled", "disabled");
     
     if($(this).attr("ready-to-add") == "true"){
     
      document.dispatchEvent(new CustomEvent("theme:loading:start"));

       var formData = {
            'items': [{
            'id': parentWrapper.find(".main-variants-select").val(),
            'quantity': 1
            }]
            };
       
      fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(formData),
          credentials: "same-origin",
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      }).then(function (e) {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          e.ok
              ? (button.removeAttr("disabled"), document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: 1 } })))
              : e.json().then(function (e) {
                    var t = document.createElement("span");
                    (t.className = "ProductForm__Error Alert Alert--error"),
                        (t.innerHTML = e.description),
                        button.removeAttr("disabled"),
                        button.after(t),
                        setTimeout(function () {
                            t.remove();
                        }, 2500);
                });
      });
                                    
     }else if($(this).attr("ready-to-remove") == "true"){
       var id = $(this).attr("data-id");
       
       document.dispatchEvent(new CustomEvent("theme:loading:start"));

          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
          body: JSON.stringify( { id: id, quantity: 0 }),
          credentials: "same-origin",
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      }).then(function (e) {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          e.ok
              ? (button.removeAttr("disabled"), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 })))
              : e.json().then(function (e) {
                    var t = document.createElement("span");
                    (t.className = "ProductForm__Error Alert Alert--error"),
                        (t.innerHTML = e.description),
                        button.removeAttr("disabled"),
                        button.after(t),
                        setTimeout(function () {
                            t.remove();
                        }, 2500);
                });
          });  
       
     }else{
       parentWrapper.find('.cart_free_product_options').addClass('active');
       $(this).html("Select an option");
     }
  });


   $('body').on('change','.cart_free_product_options-item .options-select', function(e) { 
      var parentWrapper = $(this).closest(".cart_free_product");
      var productJSON = JSON.parse(parentWrapper.find("[ data-free_product-json]").html());
      var mainSelect = parentWrapper.find(".main-variants-select");
      var selectButton = parentWrapper.find(".select_button");
      var variantImage = parentWrapper.find(".cart_free_product_info img");

      var pickedOptions = [];
      parentWrapper.find(".options-select").each(function(index, select){      
        pickedOptions.push(select.value);
      });
      var selectedVariant = false;
      var checkForAvailability = true;
      
      productJSON.product.variants.forEach(function(variant){

        if(pickedOptions.length == 1){
          if(pickedOptions[0] == variant.option1){
            selectedVariant = variant;
          }
          
        }else if(pickedOptions.length == 2){

          if(pickedOptions[0] == variant.option1 && pickedOptions[1] == variant.option2){
            selectedVariant = variant;
          }
           if(pickedOptions[0] == "" || pickedOptions[1] == ""){
             checkForAvailability = false;
           }
          
        }else if(pickedOptions.length == 3){
          if(pickedOptions[0] == variant.option1 && pickedOptions[1] == variant.option2 && pickedOptions[2] == variant.option3){
            selectedVariant = variant;
          }
          if(pickedOptions[0] == "" || pickedOptions[1] == "" || pickedOptions[2] == ""){
             checkForAvailability = false;
           }
        }
        
      });

//debugger;
     if(selectedVariant){
       mainSelect.val(selectedVariant.id);
       selectButton.attr("ready-to-add", true);
       if(selectedVariant.available){
         selectButton.html(window.languages.productFormAddToCart);
         selectButton.removeAttr("disabled");       
       }else{
         selectButton.html(window.languages.productFormSoldOut);
         selectButton.attr("disabled",true)
       }

       if(selectedVariant.featured_image){
         variantImage.attr("src",selectedVariant.featured_image);
       }else{
         variantImage.attr("src",productJSON.product.featured_image);
       }
       
     }else if(checkForAvailability){
       selectButton.html(window.languages.productFormUnavailable);
     }
     
     
   });


     $('body').on('click','.cart-drawer-membership-header-button button', function(e) { 
     var button = $(this); 
     button.attr("disabled", "disabled");
       
     var variantID = button.attr("data-variant-id");
     var sellingPlanID = button.attr("data-selling-plan");  
      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      if(sellingPlanID != "" && sellingPlanID != null){
         var formData = {
            'items': [{
            'id': variantID,
            'selling_plan': sellingPlanID,  
            'quantity': 1
            }]
            };
      }else{
         var formData = {
            'items': [{
            'id': variantID,
            'quantity': 1
            }]
            };
      }   
       
      fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(formData),
          credentials: "same-origin",
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      }).then(function (e) {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          e.ok
              ? (button.removeAttr("disabled"), document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { quantity: 1 } })))
              : e.json().then(function (e) {
                    var t = document.createElement("span");
                    (t.className = "ProductForm__Error Alert Alert--error"),
                        (t.innerHTML = e.description),
                        button.removeAttr("disabled"),
                        button.after(t),
                        setTimeout(function () {
                            t.remove();
                        }, 2500);
                });
      });
                                    
  });
  
});